/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTasksQuery } from '../../models/get-project-tasks-query';
import { GetProjectTasksQueryResult } from '../../models/get-project-tasks-query-result';

export interface ApiProjectTaskGetProjectTasksPost$Plain$Params {
      body?: GetProjectTasksQuery
}

export function apiProjectTaskGetProjectTasksPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTaskGetProjectTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTasksQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskGetProjectTasksPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTasksQueryResult>;
    })
  );
}

apiProjectTaskGetProjectTasksPost$Plain.PATH = '/api/ProjectTask/GetProjectTasks';
